
        Component.define('block-contact', (el, params) => {
            /**
 * Each component receives the variables explained below
 *
 * @param {HTMLElement} el - Component's main DOM element
 * @param {Object} params - Params to be used
 */

const $el   = $(el);
const $form = $el.find('.form-contact');
const $open = $el.find('.open-contact');

const api = ws_url + '/contact';

let successEN = 'Thanks. Message Sent.';
let successPT = 'Obrigadx! : ) Contato enviado.';

$open.on('click', function() {
    $form.toggleClass('active');
});

$form.on('submit', function(event) {
    event.preventDefault();

    const $this   = $(this);
    const $button = $this.find('button.btn-send-form');
    const buttonHtml = $button.html();

    const $name = $this.find('[name="nome"]');
    const $contact = $this.find('[name="contato"]');
    const $company = $this.find('[name="empresa"]');
    const $message = $this.find('[name="mensagem"]');

    const data = {
        name: $name.val(),
        contact: $contact.val(),
        company: $company.val(),
        message: $message.val()
    };

    $button.addClass('loading').prop('disabled', true);

    $name.prop('disabled', true);
    $contact.prop('disabled', true);
    $company.prop('disabled', true);
    $message.prop('disabled', true);

    $.post(api, data).then((res) => {

        if(res.success) {

            $button.find('span').text(lang == 'en' ? successEN : successPT);

            $name.val('');
            $contact.val('');
            $company.val('');
            $message.val('');

            window.setInterval(function() {
                $button.html(buttonHtml);
            }, 3000);

        } else {
            alert(lang == 'en' ? 'Contact not sended.' : 'Contato não enviado.');
        }

        $button.removeClass('loading').prop('disabled', false);

        $name.prop('disabled', false);
        $contact.prop('disabled', false);
        $company.prop('disabled', false);
        $message.prop('disabled', false);
    });
});

        });